import { AriaDescriber, FocusMonitor } from '@angular/cdk/a11y';
import { Directionality } from '@angular/cdk/bidi';
import { Overlay, ScrollDispatcher } from '@angular/cdk/overlay';
import { Platform } from '@angular/cdk/platform';

import { Directive, ElementRef, HostListener, Input, NgZone, ViewContainerRef, DOCUMENT, inject } from '@angular/core';
import { MatTooltip, MatTooltipDefaultOptions, MAT_TOOLTIP_DEFAULT_OPTIONS, MAT_TOOLTIP_SCROLL_STRATEGY } from '@angular/material/tooltip';

@Directive({
    selector: '[appMatTooltip]',
    standalone:true
})
export class TooltipDisableDirective extends MatTooltip {
    private el: ElementRef;


    @Input()
    get appMatTooltip() {
        return this.message;
    }
    set appMatTooltip(txt: string) {
        this.message = txt;
    }

    constructor() {
        const el = inject(ElementRef);
        const _overlay = inject(Overlay);
        const _scrollDispatcher = inject(ScrollDispatcher);
        const _viewContainerRef = inject(ViewContainerRef);
        const _ngZone = inject(NgZone);
        const _platform = inject(Platform);
        const _ariaDescriber = inject(AriaDescriber);
        const _focusMonitor = inject(FocusMonitor);
        const _scrollStrategy = inject(MAT_TOOLTIP_SCROLL_STRATEGY);
        const _dir = inject(Directionality, { optional: true });
        const _defaultOptions = inject<MatTooltipDefaultOptions>(MAT_TOOLTIP_DEFAULT_OPTIONS, { optional: true });
        const _document = inject(DOCUMENT);

        super(
            _overlay,
            el,
            _scrollDispatcher,
            _viewContainerRef,
            _ngZone,
            _platform,
            _ariaDescriber,
            _focusMonitor,
            _scrollStrategy,
            _dir,
            _defaultOptions,
            _document
        );
    
        this.el = el;
    }

    @HostListener('mouseenter')
    check(): void {
        const el = this.el.nativeElement;
        const attr = el.getAttribute('data-truncated');
        const isTruncated = attr !== null
            ? attr === 'true'
            : el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

        this.disabled = !isTruncated;

        if (isTruncated) {
            setTimeout(() => {
                const t = this as any;
                if (t._tooltipInstance) {
                    t._tooltipInstance.message = this.message;
                    t._tooltipInstance._changeDetectorRef.detectChanges();
                    t._overlayRef?.updatePosition();
                }
            });
        }
    }

}
